module.exports = __webpack_public_path__ + "static/media/ico-less.0c9e4f4d.svg";